import React from 'react';
import { FaTwitter, FaGithub, FaDiscord } from 'react-icons/fa';

const Footer = () => (
  <footer className="footer">
    <div className="footer-links">
      <a href="#">Ecosystem</a>
      <a href="#">Community</a>
      <a href="#">Governance</a>
      <a href="#">Developers</a>
      <a href="#">Blog</a>
      <a href="#">FAQ</a>
      <a href="#">Privacy Policy</a>
      <a href="#">Trademark Policy</a>
      <a href="#">Security</a>
    </div>
    <div className="footer-social">
      <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
      <a href="https://github.com" target="_blank" rel="noopener noreferrer"><FaGithub /></a>
      <a href="https://discord.com" target="_blank" rel="noopener noreferrer"><FaDiscord /></a>
    </div>
  </footer>
);

export default Footer;
